import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "react-notifications/lib/notifications.css";
import "react-virtualized/styles.css";
import "mapbox-gl/dist/mapbox-gl.css";

import App from "./js/App";
import "./styles/index.css";
import store from "./js/store";

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);
